import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import createPaginationControl from "../Common/createPaginationControl";
import InnsynMiljogebyererList from "./InnsynMiljogebyererList";
import InnsynMiljogebyrFilterContainer from "./InnsynMiljogebyrFilterContainer";
import NavigationBarContainer from "./NavigationBarContainer";

import { getMiljogebyrList } from "../../selectors/miljogebyrerSelector";

import { getMiljogebyrer } from "../../actions/miljogebyrerActions";

import "./innsyn.css";

const PaginationControl = createPaginationControl(
  "miljogebyrer",
  {
    apiCallAction: getMiljogebyrer,
    queriesForApiReducerName: "forms.InnsynMiljogebyrerFilterFormState",
  },
  getMiljogebyrList,
);

export default function InnsynMiljogebyrPage() {
  const miljogebyrer = useSelector((state) => state.miljogebyrer);

  return (
    <Container fluid>
      <Row>
        <Col>
          <NavigationBarContainer page="miljøgebyr" />
          <div className="SearchFormDiv">
            <InnsynMiljogebyrFilterContainer />
          </div>
          <div
            className="pull-right ileggelse-list-page-total-ileggelser"
            style={{ height: 50, marginTop: 20, paddingRight: 50 }}
          >
            {miljogebyrer && miljogebyrer.total} miljøgebyrer
          </div>
          <div>
            <div className="tableContainer">
              <InnsynMiljogebyererList body={miljogebyrer} />
              <PaginationControl storeKey="miljogebyrer" />
              <div style={{ height: 50 }} />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
